import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
export function Tabs({ tabs, activeTab, onChange }) {
    return (
    // The line under the tabs is an inset shadow, not border-b: with a border
    // the active tab had to overlap it by -1px, and inside a box that scrolls
    // sideways that 1px made it scroll up and down too (arrows on the right).
    _jsx("div", { className: "flex overflow-x-auto overflow-y-hidden shadow-[inset_0_-1px_0_hsl(var(--border))]", children: tabs.map((tab) => (_jsx("button", { onClick: () => onChange(tab.key), className: cn("shrink-0 whitespace-nowrap px-4 py-2 text-sm font-medium border-b-2 transition-colors", activeTab === tab.key
                // text-brand instead of text-primary (which is too dark
                // against the dark dashboard bg to meet WCAG AA).
                ? "border-brand text-brand"
                : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted"), children: tab.label }, tab.key))) }));
}
